import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import type { MatDialog, MatDialogConfig } from '@angular/material/dialog';

export interface MessageDialogData {
	title: string;
	message: string;
	note?: string;
	confirmText?: string;
	confirmStyle?: string;
	warningNote?: boolean;
}

@Component({
	selector: 'app-message-dialog',
	templateUrl: './message-dialog.component.html',
	styleUrls: ['./message-dialog.component.scss'],
	standalone: false
})
export class MessageDialogComponent {
	public constructor (
		public dialogRef: MatDialogRef<MessageDialogComponent, boolean>,
		@Inject(MAT_DIALOG_DATA) public data: MessageDialogData
	) {}

	// A small helper to open the dialog with all the correct typing
	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<MessageDialogData>
	): MatDialogRef<MessageDialogComponent, boolean> {
		return dialog.open<MessageDialogComponent, MessageDialogData, boolean>(MessageDialogComponent, config);
	}

	public close () {
		this.dialogRef.close(null);
	}

	public confirm () {
		this.dialogRef.close(true);
	}
}
